import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cancelSubscription } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';
import type { CancelSubscriptionReq, SubscriptionDto } from '@/types/subscription';

export const useCancelSubscription = () => {
    const queryClient = useQueryClient();
    return useMutation<SubscriptionDto, unknown, CancelSubscriptionReq>({
        mutationFn: cancelSubscription,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.me() });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.changeHistory() });
        },
    });
};
